import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonTransparent from '../../common/UI/ButtonTransparent';
import ScaleController from './ScaleController';
import styles from './header.less';

const GanttHeader = (props) => {
  const { scale, onScaleChange, onToday } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <ScaleController scale={scale} onScaleChange={onScaleChange} />
      <ButtonTransparent
        className={styles.todayBtn}
        onClick={(ev) => {
          onToday();
          if (ev.detail > 0) ev.currentTarget.blur();
        }}
      >
        {t('gantt.today')}
      </ButtonTransparent>
    </div>
  );
};

export default GanttHeader;
